import { render, staticRenderFns } from "./ListPromocaoView.vue?vue&type=template&id=55930170&"
import script from "./ListPromocaoView.vue?vue&type=script&lang=ts&"
export * from "./ListPromocaoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports